<template>
  <main class="account-activated">
    <Header />
    <div class="container text-center content-thank">
      <img src="../assets/images/icon-thank-you.png" alt />
      <h1>Account <span>ACTIVATED</span></h1>
      <h2>
        Congratulations! Your account is ACTIVATED.
        <br />You can start using Dropsmart!
      </h2>
    </div>
    <Footer />
  </main>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

import { FRONTEND_URL } from "../config.js";
export default {
  name: "AccountActivatedForm",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      appUrl: FRONTEND_URL.AppUrl,
      myUrl: FRONTEND_URL.MyUrl
    }
  }  
};
</script>

<style lang="scss">
html,
body,
#app {
  height: 100%;
  overflow-x: hidden;
}
.account-activated {
  background-image: url("../assets/images/img-vectors-thankyou.png");
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  .logo img {
    max-width: 236px;
    width: 100%;
  }
}
.container {
  .row {
    min-height: 175px;
  }
  h1 {
    font-size: 36px;
    color: #000000;
    font-weight: 700;
    margin-top: 20px;
    text-transform: uppercase;
  }
  h2 {
    color: #000000;
    font-size: 22px;
    line-height: 34px;
    margin-top: 30px;
    span {
      color: #499f30;
      text-transform: capitalize;
    }
  }
}
.content-thank {
  padding: 2% 0;
}
.navbar-global-header {
  font-size: 18px;
  padding: 0 !important;
  justify-content: flex-end !important;
  li {
    align-self: center;
  }
  a {
    color: #000000 !important;
    line-height: 42px;
    padding: 0 25px !important;
    &:hover {
      color: #79b867 !important;
    }
  }
}
.tryfree a {
  background: #79b867;
  border: 2px solid #79b867;
  border-radius: 30px;
  color: #ffffff !important;
  font-weight: 700;
  line-height: 42px;
  margin: 0 15px;
  padding: 0 40px !important;
  &:hover {
    background: #000000;
    border-color: #000000;
    color: #ffffff !important;
  }
}
.login a {
  border-radius: 30px;
  border: 2px solid #79b867;
  color: #79b867 !important;
  line-height: 42px;
  min-width: 170px;
  padding: 0 45px !important;
  text-align: center;
  &:hover {
    background: #79b867;
    color: #ffffff !important;
  }
}
@media (min-width: 992px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg {
    .row {
      max-width: 1230px !important;
    }
  }
}
@media screen and (max-width: 1139px) {
  .container {
    .row {
      min-height: 110px;
    }
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 18px;
    }
  }
  .hide-small {
    display: none;
  }
}
@media screen and (min-width: 1140px) {
  .hide-lg {
    display: none;
  }
}
@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    .row {
      max-width: 1230px !important;
    }
  }
}
</style>